function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import includes from 'lodash/includes';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
export default {
  props: {
    elements: {
      type: Array,
      required: true
    },
    matches: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    moreElementsBefore: {
      type: Boolean,
      "default": false
    },
    moreElementsAfter: {
      type: Boolean,
      "default": false
    }
  },
  mounted: function mounted() {
    this.centerScroll();
  },
  updated: function updated() {
    this.centerScroll();
  },
  computed: {
    units: function units() {
      var _this = this;

      return map(groupBy(this.elements, 'unit_index'), function (v, _) {
        return _objectSpread({}, v[0], {
          token: null,
          isMatch: v.some(_this.isMatch)
        });
      });
    }
  },
  methods: {
    isMatch: function isMatch(e) {
      return includes(this.matches, e.search_index);
    },
    centerScroll: function centerScroll() {
      var containerWidth = this.$refs.tokensTable.offsetWidth;
      var matchElement = this.$refs.tokensTable.querySelector('table tr:first-child td.match');
      this.$refs.tokensTable.scrollLeft = matchElement.offsetLeft + matchElement.offsetWidth / 2 - containerWidth / 2;
    }
  }
};